import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/no-find-dom-node */
import * as React from 'react';
import { findDOMNode, createPortal } from 'react-dom';
import classNames from 'classnames';
import { window, document } from '../../helpers/BrowserHelpers';
import ArrowContainer from './ArrowContainer';
var DEFAULT_POSITIONS = ['top', 'left', 'right', 'bottom'];
var CONTAINER_CLASS_NAME = 'slite-popover-container color-mode-elevated';

var getContainerRect = function getContainerRect(container) {
  if (container === window || container === document.body) {
    return {
      top: window.pageYOffset,
      left: window.pageXOffset,
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  return container.getBoundingClientRect();
};

var hasTargetRectChanged = function hasTargetRectChanged(oldPositon, newPosition) {
  return !oldPositon || oldPositon.left !== newPosition.left || oldPositon.top !== newPosition.top || oldPositon.width !== newPosition.width || oldPositon.height !== newPosition.height;
};

var TinyPopover =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TinyPopover, _React$PureComponent);

  function TinyPopover() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TinyPopover);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TinyPopover)).call.apply(_getPrototypeOf2, [this].concat(_args)));

    _defineProperty(_assertThisInitialized(_this), "targetRef", null);

    _defineProperty(_assertThisInitialized(_this), "tooltipRef", null);

    _defineProperty(_assertThisInitialized(_this), "closingTimeout", null);

    _defineProperty(_assertThisInitialized(_this), "state", {
      visible: false
    });

    _defineProperty(_assertThisInitialized(_this), "onTooltipRef", function (ref) {
      _this.props.onTooltipRef(ref);

      if (!ref) {
        return;
      }

      _this.tooltipRef = ref;
      _this.props.isOpen && _this.forceUpdate();
    });

    _defineProperty(_assertThisInitialized(_this), "onOpen", function () {
      _this.props.onPopoverOpening();

      window.addEventListener('mousedown', _this.onWindowMouseDown, {
        passive: true
      });
      window.addEventListener('wheel', _this.onWheel, {
        passive: true
      });
      window.addEventListener('resize', _this.onResize, {
        passive: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClosing", function () {
      _this.closingTimeout = setTimeout(function () {
        // TinyPopover could have been reopened in the meantime !
        if (_this.props.isOpen) {
          return;
        }

        _this.tooltipRef = null;

        _this.setState({
          visible: false
        });
      }, _this.props.transitionDuration * 1000);
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      window.removeEventListener('mousedown', _this.onWindowMouseDown, {
        passive: true
      });
      window.removeEventListener('wheel', _this.onWheel);
      window.removeEventListener('resize', _this.onResize);
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowMouseDown", function (event) {
      var onClickOutside = _this.props.onClickOutside;

      if ((!_this.targetRef || !_this.targetRef.contains(event.target)) && (!_this.tooltipRef || !_this.tooltipRef.contains(event.target))) {
        onClickOutside(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "stopPropagation", function (event) {
      event.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_this), "onWheel", function (event) {
      var newTargetRect = _this.targetRef.getBoundingClientRect();

      if (hasTargetRectChanged(_this.targetRect, newTargetRect)) {
        _this.targetRect = newTargetRect;

        _this.forceUpdate();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onResize", function (event) {
      if (!_this.tooltipRef) {
        return;
      }

      _this.forceUpdate();
    });

    _defineProperty(_assertThisInitialized(_this), "alignHorizontally", function (_ref, containerRect) {
      var targetWidth = _ref.targetWidth,
          targetLeft = _ref.targetLeft,
          tooltipWidth = _ref.tooltipWidth;
      var _this$props = _this.props,
          align = _this$props.align,
          windowBorderPadding = _this$props.windowBorderPadding;
      var left = targetLeft + targetWidth / 2 - tooltipWidth / 2;

      if (align === 'start') {
        left = targetLeft;
      }

      if (align === 'end') {
        left = targetLeft + targetWidth - tooltipWidth;
      }

      if (left - window.pageXOffset + containerRect.left < windowBorderPadding) {
        left = Math.min(windowBorderPadding + window.pageXOffset - containerRect.left, targetLeft + windowBorderPadding);
      }

      if (left - window.pageXOffset + containerRect.left + tooltipWidth > window.innerWidth - windowBorderPadding) {
        left = Math.max(window.innerWidth - windowBorderPadding - tooltipWidth + window.pageXOffset - containerRect.left, targetLeft + targetWidth - tooltipWidth - windowBorderPadding);
      }

      return left;
    });

    _defineProperty(_assertThisInitialized(_this), "alignVertically", function (_ref2, containerRect) {
      var targetTop = _ref2.targetTop,
          targetHeight = _ref2.targetHeight,
          tooltipHeight = _ref2.tooltipHeight;
      var _this$props2 = _this.props,
          align = _this$props2.align,
          windowBorderPadding = _this$props2.windowBorderPadding;
      var top = targetTop + targetHeight / 2 - tooltipHeight / 2;

      if (align === 'start') {
        top = targetTop;
      }

      if (align === 'end') {
        top = targetTop + targetHeight - tooltipHeight;
      }

      if (top - window.pageYOffset + containerRect.top < windowBorderPadding) {
        top = Math.min(windowBorderPadding + window.pageYOffset - containerRect.top, targetTop + windowBorderPadding);
      }

      if (top - window.pageYOffset + containerRect.top + tooltipHeight > window.innerHeight - windowBorderPadding) {
        top = Math.max(window.innerHeight - windowBorderPadding - tooltipHeight + window.pageYOffset - containerRect.top, targetTop + targetHeight - tooltipHeight - windowBorderPadding);
      }

      return top;
    });

    _defineProperty(_assertThisInitialized(_this), "getPosition", function (targetRect, containerRect) {
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var defaultPosition = {
        top: 0,
        left: 0,
        opacity: 0
      };
      var bypassCollision = index >= _this.positionOrder.length;

      if (!_this.tooltipRef) {
        return defaultPosition;
      }

      var currentIndex = bypassCollision ? 0 : index;
      var top, left;
      var _this$props3 = _this.props,
          verticalPadding = _this$props3.verticalPadding,
          horizontalPadding = _this$props3.horizontalPadding,
          withArrow = _this$props3.withArrow,
          arrowSize = _this$props3.arrowSize,
          isOpen = _this$props3.isOpen;
      var verticalPaddings = verticalPadding + (withArrow ? arrowSize : 0);
      var horizontalPaddings = horizontalPadding + (withArrow ? arrowSize : 0);
      var position = _this.positionOrder[currentIndex];
      var targetWidth = targetRect.width,
          targetHeight = targetRect.height;
      var targetTop = targetRect.top - containerRect.top,
          targetLeft = targetRect.left - containerRect.left;

      var _this$tooltipRef$getB = _this.tooltipRef.getBoundingClientRect(),
          tooltipWidth = _this$tooltipRef$getB.width,
          tooltipHeight = _this$tooltipRef$getB.height;

      switch (position) {
        case 'top':
          {
            top = targetTop - tooltipHeight - verticalPaddings;
            left = _this.alignHorizontally({
              targetWidth: targetWidth,
              targetLeft: targetLeft,
              tooltipWidth: tooltipWidth
            }, containerRect);
            break;
          }

        case 'bottom':
          {
            top = targetTop + targetHeight + verticalPaddings;
            left = _this.alignHorizontally({
              targetWidth: targetWidth,
              targetLeft: targetLeft,
              tooltipWidth: tooltipWidth
            }, containerRect);
            break;
          }

        case 'left':
          {
            left = targetLeft - tooltipWidth - horizontalPaddings;
            top = _this.alignVertically({
              targetHeight: targetHeight,
              targetTop: targetTop,
              tooltipHeight: tooltipHeight
            }, containerRect);
            break;
          }

        case 'right':
          {
            left = targetLeft + targetWidth + horizontalPaddings;
            top = _this.alignVertically({
              targetHeight: targetHeight,
              targetTop: targetTop,
              tooltipHeight: tooltipHeight
            }, containerRect);
            break;
          }

        default:
          return defaultPosition;
      }

      var tooltipPosition = {
        position: position,
        top: top,
        left: left,
        width: tooltipWidth,
        height: tooltipHeight,
        opacity: isOpen ? 1 : 0
      };

      if (!bypassCollision && _this.isColliding(tooltipPosition, containerRect)) {
        return _this.getPosition(targetRect, containerRect, index + 1);
      }

      return tooltipPosition;
    });

    _defineProperty(_assertThisInitialized(_this), "getContent", function (args) {
      var content = _this.props.content;
      return typeof content === 'function' ? content(args) : content;
    });

    return _this;
  }

  _createClass(TinyPopover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.positionOrder = this.getPositionPriorityOrder();
      this.targetRef = findDOMNode(this);

      if (this.props.isOpen) {
        this.onOpen();
        this.forceUpdate();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpen = this.props.isOpen;

      if (!this.targetRef) {
        this.targetRef = findDOMNode(this);
      }

      if (!prevProps.isOpen && isOpen) {
        this.onOpen();
      }

      if (prevProps.isOpen && !isOpen) {
        this.onClose();
        this.onClosing();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.onClose();
      clearTimeout(this.closingTimeout);
    }
  }, {
    key: "getPositionPriorityOrder",
    value: function getPositionPriorityOrder() {
      var position = this.props.position;
      var remainingPositions = DEFAULT_POSITIONS.filter(function (defaultPosition) {
        return defaultPosition !== position;
      });
      return [position].concat(_toConsumableArray(remainingPositions));
    }
  }, {
    key: "isColliding",
    value: function isColliding(_ref3, containerRect) {
      var top = _ref3.top,
          left = _ref3.left,
          width = _ref3.width,
          height = _ref3.height;
      var windowBorderPadding = this.props.windowBorderPadding;
      var relativeTop = top - window.pageYOffset + containerRect.top;
      var relativeLeft = left - window.pageXOffset + containerRect.left;
      return relativeTop < windowBorderPadding || relativeTop + height > window.innerHeight - windowBorderPadding || relativeLeft < windowBorderPadding || relativeLeft + width > window.innerWidth - windowBorderPadding;
    }
  }, {
    key: "renderTooltipPortal",
    value: function renderTooltipPortal() {
      if (!this.targetRef) {
        return null;
      }

      var _this$props4 = this.props,
          className = _this$props4.className,
          containerStyle = _this$props4.containerStyle,
          transitionDuration = _this$props4.transitionDuration,
          withArrow = _this$props4.withArrow,
          arrowColor = _this$props4.arrowColor,
          arrowSize = _this$props4.arrowSize,
          arrowStyle = _this$props4.arrowStyle,
          container = _this$props4.container;
      var targetRect = this.targetRef.getBoundingClientRect();
      var containerRect = getContainerRect(container);
      var tooltipPosition = this.getPosition(targetRect, containerRect);
      var top = tooltipPosition.top,
          left = tooltipPosition.left,
          opacity = tooltipPosition.opacity,
          position = tooltipPosition.position;
      var styles = typeof containerStyle === 'function' ? containerStyle(targetRect) : containerStyle;
      return createPortal(React.createElement("div", {
        ref: this.onTooltipRef,
        className: classNames(CONTAINER_CLASS_NAME, className),
        style: _objectSpread({
          position: 'absolute',
          top: top,
          left: left,
          opacity: opacity,
          zIndex: 9,
          transition: "opacity ".concat(transitionDuration, "s")
        }, styles),
        onMouseDown: this.stopPropagation,
        onClick: this.stopPropagation,
        onMouseOver: this.stopPropagation
      }, this.getContent(), withArrow && this.tooltipRef && React.createElement(ArrowContainer, {
        position: position,
        arrowColor: arrowColor,
        arrowSize: arrowSize,
        style: arrowStyle,
        targetRect: targetRect,
        popoverRect: tooltipPosition
      })), container);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          isOpen = _this$props5.isOpen;
      var visible = this.state.visible;
      return React.createElement(React.Fragment, null, children, (isOpen || visible) && this.renderTooltipPortal());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.isOpen && !state.visible) {
        return {
          visible: true
        };
      }

      return null;
    }
  }]);

  return TinyPopover;
}(React.PureComponent);

_defineProperty(TinyPopover, "defaultProps", {
  isOpen: false,
  horizontalPadding: 6,
  verticalPadding: 6,
  windowBorderPadding: 6,
  position: ['top', 'right', 'left', 'bottom'],
  align: 'center',
  className: '',
  transitionDuration: 0.35,
  withArrow: false,
  arrowSize: 10,
  onClickOutside: function onClickOutside() {
    return true;
  },
  onTooltipRef: function onTooltipRef() {
    return true;
  },
  container: document.body,
  onPopoverOpening: function onPopoverOpening() {}
});

export { TinyPopover as default };